import { Routes, RouterModule } from '@angular/router';

// Route for content layout without sidebar, navbar and footer for pages like Login, Registration etc...

export const CONTENT_ROUTES: Routes = [
  {
    path: 'vista-plan',
    loadChildren: () => import('../../assembly-view/assembly-view.module').then(m => m.AssemblyViewModule)
  },
  {
    path: 'ingresar',
    loadChildren: () => import('../../auth/auth.module').then(m => m.AuthModule)
  },
];
